import script from "./AppRenderer.vue?vue&type=script&lang=js"
export * from "./AppRenderer.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__